<template>
  <div class="inner">
    <div class="pc">
      <div class="banner">
        <div class="banner">
          <img src="img/zbj.png" alt="" />
          <div class="mask">
            <div class="box">Innovation</div>
          </div>
        </div>
      </div>
      <div class="content">
        <h3>Innovation</h3>
        <div class="module1">
          <div class="left"><img src="img/zs.jpg" alt="" /></div>
          <div class="right">
            <img src="img/idea 8.png" alt="" />
            <h4><span>Patent</span> lnvention</h4>
            <p>
              Over time, Kenta has succesfully apllied and <br />
              been granted more than 75 Patents and <br />
              lnnovations, including Stack Mold and <br />
              Vaccuum Mold.
            </p>
          </div>
        </div>
        <div class="module2">
          <div class="left">
            <img src="img/steering-wheel 1.png" alt="" />
            <h4><span>Confo</span>rmal Cooling Channel</h4>
            <p>
              KENTA has established a conformal cooling <br />
              channel design team for since 2013, a laser <br />
              sintereing metal 3D printer was invested in 2018 <br />
              to produce conformal panel parts in house.The <br />
              purpose is to shorten the cycle and improve <br />
              quality problems such as shrinkage and <br />
              deformation.
            </p>
          </div>
          <div class="right"><img src="img/图片3 1.png" alt="" /></div>
        </div>
        <div class="module3">
          <div class="left"><img src="img/图片2 1-1.png" alt="" /></div>
          <div class="right">
            <img src="img/block 2.png" alt="" />
            <h4><span>Precis</span>ion Plastic Mold</h4>
            <h4>Tooling design</h4>
            <p>
              our design team develops tooling design <br />
              using software such as Mold Flow, to create <br />
              the most reliable and optimized tool
            </p>
            <p>
              our design team develops tooling designusing software such as Mold
              Flow, to createthe most reliable and optimized tool structure, we
              develop our tools in discussion <br />
              with our clients for continuous improvement. <br />
              A comprehensive Design FEMA report can be <br />
              provided to our customer for idea exchange <br />
              and approval purpose.Also, the Kenta design <br />
              team can provide concepts such as stack <br />
              molding for larger volume parts or conformal <br />
              cooling channels for challenging design.
            </p>
            <h4>Tooling fabrication</h4>
            <p>
              our highly-specialized tooling department is <br />
              staffed by highly skilled and competent <br />
              toolmakers. Kenta has invested heavily and <br />
              equipped our facilities with world's class <br />
              processing machines (Roders、Agie etc); we <br />
              have constant temperature workshop <br />
              environment, which guarantees quality and <br />
              repeatability for the manufacturing & research <br />
              of complicated and high precision injection <br />
              tooling. Kenta have systemic tool making
              <br />
              planning and a separate dimension measuringcenter located in tool
              shop, Kenta providescompetitive lead-times for quick turnaround
              <br />
              projects.
            </p>
          </div>
        </div>
        <div class="module4">
          <div class="left">
            <img src="img/system 2.png" alt="" />
            <h4><span>Produ</span>ction & Systems Management</h4>
            <p>
              The recent trend in plastic production dictated by <br />
              lndustry 4.0 demands is to acquire a great deal of <br />
              data for manufacturing process control. Kenta <br />
              has implemented a knowledge-based <br />
              management system. Different systems of ERP, <br />
              MES.PLM and WMs have been launched successively to promote
              digitalization. These <br />
              allow us to fully understand the real time status <br />
              at any stage through an engagement; we utilize <br />
              the system to review past, current and predict <br />
              future performance, which allows us to optimizeeach stage.
              guaranteeing repeatable, on time, <br />
              best cost, quality praducts.
            </p>
          </div>
          <div class="right"><img src="img/zbj.png" alt="" /></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.pc {
  .banner {
    height: 29vw;
    overflow: hidden;
    text-align: center;
    position: relative;
    img {
      width: 120%;
      position: relative;
      top: -15vw;
      left: -15vw;
      z-index: 0;
    }
    .mask {
      position: absolute;
      top: 0;
      background: rgba(15, 15, 15, 0.301);
      width: 100%;
      height: 100%;
      .box {
        position: absolute;
        bottom: 0;
        width: 50%;
        height: 15%;
        left: 0;
        top: 0;
        right: 0;
        margin: auto;
        color: white;
        font-size: 4vw;
        font-weight: 800;
      }
    }
  }
  h3 {
    width: 100%;
    margin: 3vw auto;
    font-size: 2vw;
  }
  h4 {
    font-size: 1.5vw;
    margin: 2vw 0;
    span {
      border-bottom: red solid 0.2vw;
      padding-bottom: 1vw;
    }
  }
  .content {
    width: 70%;
    margin: 0 auto;
    > div {
      display: flex;
      justify-content: space-between;
      margin: 5vw 0;
      > div {
        width: 50%;
        box-sizing: border-box;
        overflow: hidden;
        p {
          color: gray;
          font-size: 1vw;
        }
      }
    }
    .module1 {
      .left {
        text-align: center;
        img {
          width: 110%;
        }
      }
      .right {
        img {
          width: 15%;
        }
        padding: 2vw 6vw;
      }
    }
    .module2 {
      .left {
        img {
          width: 10%;
        }
      }
      .right {
        text-align: center;
        img {
          width: 80%;
        }
      }
    }
    .module3 {
      .left {
        img {
          width: 100%;
          position: relative;
          bottom: -12vw;
        }
      }
      .right {
        img {
          width: 15%;
        }
        padding: 2vw 6vw;
      }
    }
    .module4 {
      .left {
        img {
          width: 15%;
        }
      }
      .right {
        overflow: hidden;
        img {
          width: 150%;
        }
      }
    }
  }
}
</style>